import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Input } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/AuthContext';
import './Signup.css';

const Signup = () => {
    const { signup } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    const handleSignup = async (e) => {
        e.preventDefault();
        if (password !== password2) {
            setError('As senhas não são iguais.');
            return;
        }
        const success = await signup(email, password, name);
        if (!success) {
            setError('Erro ao registra-se. Usuário já existe.');
        } else {
            navigate('/dashboard');
        }
    };

    return (
        <form onSubmit={handleSignup} className='SignupForm'>
            <h2>Registrar-se</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <div className='SignupInput'>
                <Input type="text" value={name} placeholder="Seu nome" onChange={(e) => setName(e.target.value)} />
            </div>
            <div className='SignupInput'>
                <Input type="email" value={email} placeholder="Seu@email" onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className='SignupInput'>
                <Input.Password
                    placeholder="Sua senha"
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>
            <div className='SignupInput'>
                <Input.Password
                    placeholder="Confirme sua senha"
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    onChange={(e) => setPassword2(e.target.value)}
                />
            </div>
            <button className="SignupButton" type="submit">Enviar</button>
        </form>
    );
};

export default Signup;
